import React, {PureComponent} from 'react'
import Store from 'Store'
import {inject, observer} from 'mobx-react'
import BusinessUnit from '../Model'
import history from 'helpers/History'
import {Table} from 'components'
import {loading} from 'elements/Loading'
import OperationLine from '../Model'
import {log} from 'util'
import ReceiptLayout from '../Model'

interface Props {
  store?: Store
  operationLines: OperationLine[]
  businessUnits: BusinessUnit[]
  receiptLayouts: ReceiptLayout[]
}

@inject('store')
@loading<Props>(props => {
  return [
    props.store!.operationLines.read().then(operationLines => ({operationLines})),
    props.store!.businessUnits.read().then(businessUnits => ({businessUnits})),
    props.store!.receipLayouts.read().then(receiptLayouts => ({receiptLayouts}))
  ]
})
@observer
export default class OperationLinesTable extends PureComponent<Props, object> {

  componentDidMount(): void {
    console.log('componentDidMount')
    // this.props.store!.operationLines.read()
    // this.props.store!.businessUnits.read()
    // this.props.store!.receipLayouts.read()
  }

  handleSelectItem = (value: BusinessUnit) => {
    history.push(`/operationlines/${value.id}`)
  }

  handleCreate = () => {
    history.push(`/operationlines/create`)
  }

  mapea = (values, businessUnits, receiptLayouts) => {
    return values.map(item => {
      const businessUnit = businessUnits.filter(ol => {
        return ol.id === item.businessUnit_id
      })[0]
      const operationLineString = 'businessUnit'
      item[operationLineString] = businessUnit ? businessUnit.name : ''

      const receiptLayout = receiptLayouts.filter(ol => {
        return ol.id === item.receiptLayout_id
      })[0]
      const receiptLayoutString = 'receiptLayout'
      item[receiptLayoutString] = receiptLayout ? receiptLayout.name : ''
      console.log('item', item)
      return item
    })
  }

  render() {
    let operationLines: OperationLine[] | undefined = this.props.operationLines
    const {businessUnits} = this.props
    const {receiptLayouts} = this.props
    // console.log('operationLines', operationLines)
    const mapeados = this.mapea(operationLines, businessUnits, receiptLayouts)
    const headers = this.props.store!.UI.isDesktop
      ? ['name', 'code', 'businessUnit', 'receiptLayout']
      : ['name', 'code', 'businessUnit', 'receiptLayout']

    if (!(businessUnits.length > 0))
      return <div><text>No hay negocios dados de alta, por favor cree uno antes</text> </div>

    return (
      <Table
        /*items={operationLines.data}*/
        items={mapeados}
        header={headers}
        onSelectItem={this.handleSelectItem}
        onCreate={this.handleCreate}
        keyExtractor={(item: BusinessUnit) => String(item.id)}
        loading={operationLines===undefined || businessUnits===undefined || receiptLayouts===undefined}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/modules/OperationLines/container/OperationLinesTable.tsx